import { useQueryClient as r, useMutation as u } from "@tanstack/vue-query";
import { adGroupKeys as o } from "../ad-group/queries.js";
import { creativeGroupKeys as y } from "../creative-group/queries.js";
import { targetGroupKeys as m } from "../target-group/queries.js";
import { campaignKeys as t } from "./queries.js";
const q = (s, c) => {
  const n = r(), e = c?.onSuccess;
  return u({
    ...c,
    mutationFn: async (a) => {
      const i = a.body;
      return s.campaign.create(i);
    },
    onSuccess: async (...a) => {
      await n.invalidateQueries({ queryKey: t.all }), e && e(...a);
    }
  });
}, I = (s, c) => {
  const n = r(), e = c?.onSuccess;
  return u({
    ...c,
    mutationFn: async (a) => {
      const i = {
        campaignId: a.campaignId,
        ...a.body
      };
      await s.campaign.update(i);
    },
    onSuccess: async (...a) => {
      await n.invalidateQueries({ queryKey: t.all }), e && e(...a);
    }
  });
}, S = (s, c) => {
  const n = r(), e = c?.onSuccess;
  return u({
    ...c,
    mutationFn: async (a) => {
      const i = {
        campaignId: a.campaignId,
        ...a.body
      };
      await s.campaign.rename(i);
    },
    onSuccess: async (...a) => {
      await n.invalidateQueries({ queryKey: t.all }), e && e(...a);
    }
  });
}, f = (s, c) => {
  const n = r(), e = c?.onSuccess;
  return u({
    ...c,
    mutationFn: async (a) => s.campaign.remove({
      params: { campaignId: a.campaignId },
      query: { force: a.force ?? !1 }
    }),
    onSuccess: async (...a) => {
      const [, i] = a;
      n.removeQueries({ queryKey: t.byCampaign(i.campaignId) }), n.removeQueries({ queryKey: o.byCampaign(i.campaignId) }), n.removeQueries({ queryKey: y.byCampaign(i.campaignId) }), n.removeQueries({ queryKey: m.byCampaign(i.campaignId) }), await n.invalidateQueries({ queryKey: t.all }), e && e(...a);
    }
  });
}, K = (s, c) => {
  const n = r();
  return u({
    ...c,
    mutationFn: async (e) => {
      const a = {
        campaignId: e.campaignId,
        ...e.body
      };
      await s.campaign.update(a);
    },
    onMutate: async (e) => {
      await n.cancelQueries({
        queryKey: t.detail(e.campaignId)
      });
      const a = n.getQueryData(t.detail(e.campaignId));
      return a && n.setQueryData(t.detail(e.campaignId), {
        ...a,
        ...e.body
      }), { previousDetail: a };
    },
    onError: (e, a, i) => {
      i?.previousDetail !== void 0 && n.setQueryData(t.detail(a.campaignId), i.previousDetail);
    },
    onSettled: async () => {
      await n.invalidateQueries({ queryKey: t.all });
    }
  });
}, Q = (s, c) => {
  const n = r(), e = c?.onSuccess;
  return u({
    ...c,
    mutationFn: async (a) => {
      const i = { campaignId: a.campaignId, ...a.body };
      return s.campaign.copy(i);
    },
    onSuccess: async (...a) => {
      await n.invalidateQueries({ queryKey: t.all }), e && e(...a);
    }
  });
};
export {
  Q as useCopyCampaign,
  q as useCreateCampaign,
  f as useDeleteCampaign,
  S as useRenameCampaign,
  I as useUpdateCampaign,
  K as useUpdateCampaignOptimistic
};
//# sourceMappingURL=mutations.js.map
